import CustomizedDialogs from "../../atoms/dialog";
import { Grid, TextField, MenuItem, Button } from '@material-ui/core';
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { handleSnackBar } from "../../../store/global/actions";
import { useDispatch } from "react-redux";
import { invokePostService } from '../../../store/global/actions'

export default function TransferOwnership({ setIsTransferOwnership, sharedMembers, getSharedList, isTransferAndLeave, setIsTransferAndLeave }) {

    const { register, handleSubmit, formState: { errors }, control } = useForm();
    const dispatch = useDispatch();
    const history = useHistory();
    const currentOwner = sharedMembers.find(ele => ele.access_level === 'OWNER');
   
    const onTransferOwnership = ({ member }) => {
        const payLoad = {
            transferTo: member,
            blueprintId: currentOwner.blueprint_id._id,
            memberId: currentOwner._id,
            isTransferAndLeave: isTransferAndLeave
        }
        dispatch(invokePostService('transferOwnership', {...payLoad})).then(res => {
            setIsTransferOwnership(false);
            if (res?.status == true) {
                getSharedList();
                if (isTransferAndLeave) {
                    history.push(`/`);
                }
                dispatch(handleSnackBar({ open: true, message: res?.message, severity: "success" }));
            } else {
                dispatch(handleSnackBar({ open: true, message: res?.message, severity: "error" }));
            }
        });
    }

    const handleClose = () => {
        setIsTransferOwnership(false);
        setIsTransferAndLeave(false);
    }


    return (<CustomizedDialogs
        open={true}
        title={isTransferAndLeave ? "Transfer Ownership and Leave" : "Transfer Ownership"}
        handleClose={handleClose}
    >
        <Grid container direction="row" spacing={2}>
            <Grid item xs={6}>
                <Controller
                    name="member"
                    control={control}
                    defaultValue={''}
                    rules={{ required: true }}
                    render={({ field, value, onChange }) =>
                        <TextField
                            {...field}
                            name="member"
                            label={'Members'}
                            select
                            fullWidth
                            variant={'outlined'}
                            size={'small'}
                            value={value}
                            onChange={e => { onChange(e) }}
                            error={errors.member ? true : false}
                            helperText={errors?.member ? 'Please select a member' : ''}
                        >   <MenuItem key={123} value={""}>Select an admin</MenuItem>
                            {sharedMembers.filter(ele => ele.access_level === 'ADMIN').map((option) => (
                                <MenuItem key={option.userId.username} value={option.userId._id}>
                                    {`${option.userId.firstName} ${option.userId.lastName} (${option.userId.username})`}
                                </MenuItem>
                            ))}
                        </TextField>
                    }
                />
            </Grid>
            <Grid item xs={6} container justifyContent="flex-end">
                <Button onClick={handleSubmit(onTransferOwnership)} style={{textTransform: 'capitalize'}} id={isTransferAndLeave ? 'transfer_leave' : "transfer"} variant="contained" color="primary">{isTransferAndLeave ? 'Transfer and leave' : 'Transfer'}</Button>
                <Button variant="contained" onClick={handleClose} style={{ marginLeft: 10, textTransform: 'capitalize' }}>Cancel</Button>
            </Grid>
        </Grid>
    </CustomizedDialogs>)
}